import { Controller } from "@hotwired/stimulus";
export default class default_1 extends Controller {
    connect() {
        // Listen for date changes only - not on focus
        const dateInput = this.element.querySelector('input[name="departingDate"]');
        if (dateInput) {
            this.dateInputTarget = dateInput;
            dateInput.addEventListener('change', () => {
                console.log('Date changed:', dateInput.value);
                this.showTimeSelection();
            });
            // Hide display when user focuses on date input
            dateInput.addEventListener('focus', () => {
                if (this.dateDisplayTarget) {
                    this.dateDisplayTarget.classList.add('hidden');
                }
            });
            // Show display when user blurs from date input (if we have a time selected)
            dateInput.addEventListener('blur', () => {
                if (this.dateDisplayTarget && this.timeInputTarget.value) {
                    setTimeout(() => {
                        this.dateDisplayTarget.classList.remove('hidden');
                    }, 100);
                }
            });
            // Remove the focus listener to prevent showing time selection before date is selected
            // dateInput.addEventListener('focus', () => {
            //   this.showTimeSelection();
            // });
        }
        // Set up time option clicks
        this.timeOptionTargets.forEach(option => {
            option.addEventListener('click', (e) => {
                const time = e.target.getAttribute('data-time');
                if (time) {
                    this.selectTime(time);
                }
            });
        });
        // Handle form submission to ensure original date value is used
        const form = this.element.closest('form');
        if (form) {
            form.addEventListener('submit', () => {
                this.restoreOriginalDateValue();
            });
        }
    }
    showTimeSelection() {
        console.log('showTimeSelection called');
        console.log('timeSelectionTarget:', this.timeSelectionTarget);
        this.timeSelectionTarget.classList.remove('hidden');
    }
    selectTime(time) {
        this.timeInputTarget.value = time;
        // Update button styles
        this.timeOptionTargets.forEach(option => {
            const optionTime = option.getAttribute('data-time');
            if (optionTime === time) {
                option.classList.remove('bg-gray-100');
                option.classList.add('bg-brand-sea', 'text-white');
            }
            else {
                option.classList.remove('bg-brand-sea', 'text-white');
                option.classList.add('bg-gray-100');
            }
        });
        // Close the time selection popup
        this.timeSelectionTarget.classList.add('hidden');
        // Update the date input to show the selected time
        this.updateDateInputDisplay(time);
    }
    updateDateInputDisplay(time) {
        if (!this.dateInputTarget || !this.dateDisplayTarget)
            return;
        const originalDate = this.dateInputTarget.value;
        if (!originalDate)
            return;
        // Format the date for display
        const date = new Date(originalDate);
        const formattedDate = date.toLocaleDateString('en-US', {
            weekday: 'short',
            month: 'short',
            day: 'numeric'
        });
        // Format the time for display
        let timeDisplay = '';
        if (time === 'flexible') {
            timeDisplay = '\nAny time';
        }
        else {
            const timeDate = new Date(`2000-01-01T${time}`);
            const timeString = timeDate.toLocaleTimeString('en-US', {
                hour: 'numeric',
                minute: '2-digit',
                hour12: true
            });
            // Split time into hour and AM/PM
            const timeParts = timeString.split(' ');
            const hour = timeParts[0];
            const period = timeParts[1];
            timeDisplay = `\n${hour}${period}`;
        }
        // Update the display element
        this.dateDisplayTarget.textContent = formattedDate + timeDisplay;
        this.dateDisplayTarget.classList.remove('hidden');
        // Store the original value for form submission
        this.dateInputTarget.setAttribute('data-original-value', originalDate);
    }
    restoreOriginalDateValue() {
        if (!this.dateInputTarget)
            return;
        const originalValue = this.dateInputTarget.getAttribute('data-original-value');
        if (originalValue) {
            this.dateInputTarget.value = originalValue;
        }
    }
}
default_1.targets = ["timeSelection", "timeInput", "timeOption", "dateDisplay"];
